import './assets/main.css'

import { createApp } from 'vue'
import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'

import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'

import App from './App.vue'
import router from './router'
import store from './store'

import * as Sentry from '@sentry/vue'

import _ from 'lodash'

const app = createApp(App)

app.use(ToastPlugin, {
  position: 'top',
  queue: true,
  duration: 3000,
})

app.use(VueTelInput, {
  defaultCountry: 'US',
})

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({ router })],
    // Configure to capture Vuex state
    beforeSend(event) {
      // Add Vuex store state to the Sentry event
      if (store) {
        event.extra = {
          ...event.extra,
          vuex: {
            // You can select which parts of the state to include
            state: store.state,
            // Or filter sensitive information
            // state: filterSensitiveData(store.state)
          },
        }
      }
      return event
    },
  })
}

// app.config.errorHandler = (error, vm, info) => {
//   // Add additional context to the error
//   Sentry.configureScope((scope) => {
//     scope.setExtra('componentName', vm.$options.name)
//     scope.setExtra('lifecycleHook', info)
//   })

//   // Forward to Sentry
//   Sentry.captureException(error)

//   // Log to console in development
//   if (process.env.NODE_ENV !== 'production') {
//     console.error(error)
//   }
// }

const componentFiles = import.meta.glob('./components/**/*.vue', { eager: true })

Object.entries(componentFiles).forEach(([path, m]) => {
  const componentName = _.upperFirst(
    _.camelCase(
      path
        .split('/')
        .pop()
        .replace(/\.\w+$/, ''),
    ),
  )

  app.component(`${componentName}`, m.default)
})

app.config.globalProperties.isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
  window.innerWidth < 768
    ? true
    : false
app.config.globalProperties.callbackNumber = '872-304-0654'
// app.config.globalProperties.emitter = emitter

app.use(router)
app.use(store)

app.mount('#app')
